<!-- Header -->
<div style="padding: 18px 20px 14px; border-bottom: 1px solid #e9ecef; position: relative;">
  <button
    type="button"
    (click)="close()"
    style="position:absolute; top:16px; right:16px; background:none; border:none; cursor:pointer; padding:0; line-height:1; font-size:20px; color:#888; display:flex; align-items:center; justify-content:center;"
  >&times;</button>
  <h6 style="font-weight:700; font-size:15px; color:#000; margin:0 0 4px;">Profile Photo</h6>
  <p style="font-size:12px; color:#000; margin:0; line-height:1.5; padding-right:20px;">
    Update your profile picture or logo to improve your branding.
  </p>
</div>

<div style="padding: 16px 20px 18px;">

  <!-- Current Photo Row -->
  <div style="background: #88888833; border-radius:10px; padding:14px; margin-bottom:14px;">
    <div style="display:flex; align-items:center; gap:14px;">

      <!-- Avatar -->
      <div class="preview-wrapper" style="flex-shrink:0; width:72px; height:72px;">
        <img
          [src]="removeState === 'removed' ? placeholder : (profilePhotoUrl || placeholder)"
          alt="Current Photo"
          [class.dimmed]="removeState === 'removing'"
          class="preview-img"
          style="width:72px; height:72px; border-radius:50%; object-fit:cover; border:2px solid #dee2e6; display:block;"
        />
        <div class="spinner-overlay" *ngIf="removeState === 'removing'">
          <img src="assets/img/brand/spinner.png" alt="spinner" />
        </div>
      </div>

      <div style="flex:1; min-width:0;">
        <div style="font-weight:700; font-size:12px; text-transform:uppercase; letter-spacing:0.5px; color:#000;">
          CURRENT PHOTO
        </div>

        <!-- confirm -->
        <ng-container *ngIf="removeState === 'confirm'">
          <div style="font-size:12px; color:#000; margin-top:2px; margin-bottom:6px;">
            Are you sure you want to remove your current profile picture?
          </div>
          <div style="display:flex; align-items:center; gap:6px;">
            <button type="button" (click)="keepPhoto()"
              style="background:transparent; border:none; border-radius:6px; padding:4px 12px; font-size:11px; font-weight:600; color:#444; cursor:pointer; line-height:1.4;">
              Keep
            </button>
            <button type="button" (click)="confirmRemove()"
              style="background:#444444; border:none; border-radius:6px; padding:4px 12px; font-size:11px; font-weight:600; color:#fff; cursor:pointer; line-height:1.4; box-shadow:0 2px 4px rgba(0,0,0,0.2);">
              Remove
            </button>
          </div>
        </ng-container>

        <!-- removing -->
        <ng-container *ngIf="removeState === 'removing'">
          <div style="font-size:12px; color:#000; margin-top:2px;">Removing your profile picture...</div>
        </ng-container>

        <!-- removed -->
        <ng-container *ngIf="removeState === 'removed'">
          <div style="font-size:11px; color:#000; font-weight:600; margin-top:2px; margin-bottom:4px;">
            Successfully removed your profile picture! Upload a new one?
          </div>
          <div style="font-size:11px; color:#888; margin-bottom:6px;">Recommended: Square JPG or PNG, 400x400px.</div>
          <label for="photoFileInput"
            style="cursor:pointer; background:#908C8C; border:none; border-radius:6px; padding:4px 10px; font-size:11px; font-weight:500; display:inline-flex; align-items:center; gap:5px; color:#fff; white-space:nowrap; margin:0; line-height:1.4; box-shadow:0 2px 4px rgba(0,0,0,0.2);">
            <img src="assets/img/icons/common/upload-icon.svg" style="width:11px; height:11px; filter:brightness(0) invert(1);" alt="upload" />
            Choose File
          </label>
        </ng-container>

        <!-- idle -->
        <ng-container *ngIf="removeState === 'idle'">
          <div style="font-size:11px; color:#000; margin-top:2px;">Recommended: Square JPG or PNG, 400x400px.</div>
          <div style="display:flex; align-items:center; gap:6px; margin-top:4px; flex-wrap:wrap;">
            <label for="photoFileInput"
              style="cursor:pointer; background:#908C8C; border:none; border-radius:6px; padding:4px 10px; font-size:11px; font-weight:500; display:inline-flex; align-items:center; gap:5px; color:#fff; white-space:nowrap; margin:0; line-height:1.4; box-shadow:0 2px 4px rgba(0,0,0,0.2);">
              <img src="assets/img/icons/common/upload-icon.svg" style="width:11px; height:11px; filter:brightness(0) invert(1);" alt="upload" />
              Choose File
            </label>
            <button *ngIf="selectedFile" type="button" (click)="removeSelectedFile()"
              style="background:transparent; border:none; padding:4px 6px; font-size:11px; color:#444444; cursor:pointer; white-space:nowrap; display:inline-flex; align-items:center; gap:4px; font-weight:600; line-height:1.4;">
              <i class="fa fa-trash" style="font-size:11px;"></i> Remove
            </button>
            <button *ngIf="canRemovePhoto" type="button" (click)="askRemove()"
              style="background:transparent; border:none; padding:4px 6px; font-size:11px; color:#444444; cursor:pointer; white-space:nowrap; display:inline-flex; align-items:center; gap:4px; font-weight:600; line-height:1.4;">
              <i class="fa fa-trash" style="font-size:11px;"></i> Remove Photo
            </button>
          </div>
        </ng-container>

      </div>
    </div>
  </div>

  <!-- Single file input — always in DOM -->
  <input
    id="photoFileInput"
    type="file"
    accept="image/png,image/jpeg,image/gif,image/webp"
    style="display:none;"
    (change)="onFileSelected($event)"
  />

  <!-- ── EXACTLY ONE DROP ZONE shown at a time ── -->

<!-- SUCCESS -->
<ng-container *ngIf="uploadState === 'success'; else notSuccess">
  <div
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    [ngStyle]="{ background: isDragging ? 'rgba(136, 136, 136, 0.3)' : '#FFFFFF' }"
    style="border:2px dashed #c8c8c8; border-radius:10px; text-align:center; padding:24px 16px; margin-bottom:14px; transition:border-color 0.2s, background 0.2s;"
  >
    <img
      [src]="profilePhotoUrl"
      alt="New Photo"
      style="width:72px; height:72px; border-radius:50%; object-fit:cover; border:3px solid #dee2e6; margin-bottom:8px; display:block; margin-left:auto; margin-right:auto;"
    />
    <div style="font-weight:700; font-size:13px; color:#000; margin-bottom:4px;">
      Your profile picture has been successfully updated!
    </div>
    <div style="font-size:11px; color:#000; margin-bottom:10px;">These changes might take a while to reflect. <br> Or drop a new photo here to replace it.</div>
  </div>
</ng-container>

<ng-template #notSuccess>

  <!-- LOADING -->
  <ng-container *ngIf="uploadState === 'loading'; else notLoading">
    <div style="border:2px dashed #c8c8c8; border-radius:10px; text-align:center; padding:30px 16px; margin-bottom:14px; background:#f8f8f8;">
      <div style="font-weight:700; font-size:13px; color:#000; margin-bottom:16px;">
        Uploading your profile picture...
      </div>
      <div class="preview-wrapper" style="margin: 0 auto 10px;">
        <img [src]="previewUrl || profilePhotoUrl || placeholder" alt="Uploading" class="preview-img dimmed" />
        <div class="spinner-overlay">
          <img src="assets/img/brand/spinner.png" alt="spinner" />
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #notLoading>

    <!-- ERROR -->
    <ng-container *ngIf="uploadState === 'error'; else notError">
      <div
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        [ngStyle]="{ background: isDragging ? '#eb34231e' : '#EB322326' }"
        style="border:2px dashed #EB3223; background:#EB322326; border-radius:10px; text-align:center; padding:28px 16px; margin-bottom:14px; transition:border-color 0.2s, background 0.2s;"
      >
        <div style="width:42px; height:42px; background:#dc3545; border-radius:50%; display:inline-flex; align-items:center; justify-content:center; margin-bottom:12px;">
          <i class="ni ni-fat-remove" style="font-size:20px; color:#fff;"></i>
        </div>
        <ng-container *ngIf="errorType === 'not-image'">
          <div style="font-weight:700; font-size:14px; color:#EB3223; margin-bottom:6px;">Chosen File is Not An Image File</div>
          <div style="font-size:12px; color:#EB3223;">Please make sure that it is a PNG, JPG, GIF, or WEBP file.</div>
        </ng-container>
        <ng-container *ngIf="errorType === 'too-large'">
          <div style="font-weight:700; font-size:14px; color:#EB3223; margin-bottom:6px;">Chosen File Has Exceeded The Size Limit</div>
          <div style="font-size:12px; color:#EB3223;">Please make sure that the file is 5 MB or less.</div>
        </ng-container>
        <ng-container *ngIf="errorType === 'no-file'">
          <div style="font-weight:700; font-size:14px; color:#EB3223; margin-bottom:6px;">No Image File Attached</div>
          <div style="font-size:12px; color:#EB3223;">Please include an image before clicking on the upload button.</div>
        </ng-container>
        <ng-container *ngIf="errorType === 'unexpected'">
          <div style="font-weight:700; font-size:14px; color:#EB3223; margin-bottom:6px;">An Unexpected Error Occurred</div>
          <div style="font-size:12px; color:#EB3223;">Please try again later.</div>
        </ng-container>
        <div style="font-size:11px; color:#EB3223; margin-top:10px;">Or drop a new image here to retry.</div>
      </div>
    </ng-container>

    <ng-template #notError>

      <!-- PREVIEW: idle + file selected -->
      <ng-container *ngIf="uploadState === 'idle' && previewUrl; else defaultZone">
        <div
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
          [ngStyle]="{ background: isDragging ? 'rgba(136, 136, 136, 0.3)' : '#FFFFFF' }"
          style="border:2px dashed #c8c8c8; border-radius:10px; text-align:center; padding:24px 16px; margin-bottom:14px; background:#ffffff; position:relative;"
        >
          <div style="font-weight:700; font-size:13px; color:#000; margin-bottom:14px;">
            Your new profile picture is ready to be uploaded!
          </div>
          <div style="position:relative; display:inline-block; margin-bottom:10px;">
            <img [src]="previewUrl" alt="Preview"
              style="width:80px; height:80px; border-radius:50%; object-fit:cover; border:3px solid #dee2e6; display:block;" />
            <button type="button" (click)="removeSelectedFile()"
              style="position:absolute; top:-4px; right:-4px; width:20px; height:20px; border-radius:50%; background:#fff; border:1px solid #dee2e6; cursor:pointer; font-size:13px; line-height:1; display:flex; align-items:center; justify-content:center; color:#555; padding:0; box-shadow:0 1px 3px rgba(0,0,0,0.15);">
              &times;
            </button>
          </div>
          <div style="font-size:11px; color:#000;">File: {{ selectedFileName }} ({{ selectedFileSizeMB }} MB)</div>
        </div>
      </ng-container>

      <!-- DEFAULT: idle no file (including after remove/confirm/removing) -->
      <ng-template #defaultZone>
        <div
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
          [ngStyle]="{ background: isDragging ? 'rgba(136, 136, 136, 0.3)' : '#FFFFFF' }"
          style="border:2px dashed #c8c8c8; border-radius:10px; text-align:center; padding:50px 16px; margin-bottom:18px; transition:border-color 0.2s, background 0.2s;"
        >
          <div style="width:42px; height:42px; background:#908C8C; border-radius:50%; display:inline-flex; align-items:center; justify-content:center; margin-bottom:10px; box-shadow:0 4px 6px rgba(0,0,0,0.2);">
            <img src="assets/img/icons/common/upload-icon.svg" style="width:20px; height:20px; filter:brightness(0) invert(1);" alt="upload" />
          </div>
          <div style="font-weight:600; color:#000; font-size:13px;">Drop the photo within the box to upload it.</div>
          <div style="color:#000; font-size:11px;">PNG, JPG, or GIF (max. 5MB)</div>
        </div>
      </ng-template>

    </ng-template>
  </ng-template>
</ng-template>
  <!-- Footer buttons -->
  <div style="margin: 4px -20px 0; border-top:1px solid #e9ecef; padding:14px 20px 0;">
    <div style="display:flex; justify-content:flex-end; gap:10px;">

      <!-- Cancel / Close — hidden during confirm -->
      <button
        *ngIf="removeState !== 'confirm'"
        type="button"
        (click)="close()"
        [disabled]="uploadState === 'loading' || removeState === 'removing'"
        [ngStyle]="{
          opacity: uploadState === 'loading' || removeState === 'removing' ? '0.4' : '1',
          cursor: uploadState === 'loading' || removeState === 'removing' ? 'not-allowed' : 'pointer'
        }"
        style="background:transparent; border:none; border-radius:6px; padding:7px 20px; font-size:13px; color:#444444; font-weight:600;"
      >
        {{ uploadState === 'success' ? 'Close' : 'Cancel' }}
      </button>

      <!-- Upload New Photo — hidden during confirm -->
      <button
        *ngIf="removeState !== 'confirm'"
        type="button"
        (click)="upload()"
        [disabled]="isUploadDisabled() || removeState === 'removing'"
        [ngStyle]="{
          background: isUploadDisabled() || removeState === 'removing' ? '#908C8C' : '#444444',
          color: isUploadDisabled() || removeState === 'removing' ? 'rgba(255,255,255,0.5)' : '#ffffff',
          cursor: isUploadDisabled() || removeState === 'removing' ? 'not-allowed' : 'pointer'
        }"
        style="border:none; border-radius:10px; padding:7px 20px; font-size:13px; font-weight:500; transition:background 0.2s; box-shadow:0 4px 6px rgba(0,0,0,0.25);"
      >
        Upload New Photo
      </button>

    </div>
  </div>

</div>